import 'assets/styles/global.scss';
import 'assets/fonts';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { BrowserRouter } from 'react-router-dom';
import routes from 'config/routes';
import ErrorBoundary from 'components/ErrorBoundary';
import { bindStore } from 'libs/store';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/core/styles';
import CreateStore from './redux';
import registerServiceWorker from './registerServiceWorker';

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: false,
  productionPrefix: 'c',
});

const initialState = {};
const store = CreateStore(initialState);
bindStore(store);

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <JssProvider generateClassName={generateClassName}>
        <BrowserRouter>
          {renderRoutes(routes)}
        </BrowserRouter>
      </JssProvider>
    </Provider>
  </ErrorBoundary>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx